import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class FilterControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: [
        {
          title: "All"
        },
        {
          title: "Electronic"
        },
        {
          title: "Hip hop"
        },
        {
          title: "Indie"
        },
        {
          title: "Pop"
        },
        {
          title: "New Zealand"
        },
        {
          title: "Chillers"
        },
        {
          title: "Thrillers"
        },
        {
          title: "Soothers"
        },
        {
          title: "Groovers"
        }
      ]
    }
  }

  _handleClick(title) {
    this.props.handler(title);
  }

  render() {
    return (
      <div className={css(styles.container)}>
        {
          this.state.filters.map(filter => {
            const isActive = this.props.filters.indexOf(filter.title.toLowerCase()) != -1;

            return (
              <div
                className={css(styles.filter_container)}
                onClick={this._handleClick.bind(this, filter.title)}>
                <a className={css(styles.filter_button, isActive ? styles.active_filter : false )}>
                  <div className={css(styles.filter_button_title)}>
                    {filter.title}
                  </div>
                </a>
              </div>
            );
          })
        }
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    width: 800,
    margin: '40px auto',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap",
    [Theme.mobile_query]: {
      display: 'none',
    }
  },
  filter_container: {
    display: 'flex',
    marginBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
    width: "20%",
    boxSizing: "border-box"
  },
  filter_button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    cursor: "pointer",
    height: 40,
    width: 140,
    backgroundColor: Theme.white,
    transition: "all 180ms ease-in-out",
    ":hover": {
      color: Theme.white,
      fontWeight: 'bold',
      backgroundColor: Theme.primary
    }
  },
  filter_button_title: {
    flex: 1,
    fontFamily: Theme.fontFamily,
    fontSize: 10,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  active_filter: {
    color: Theme.white,
    fontWeight: 'bold',
    backgroundColor: Theme.primary
  },
})



// WEBPACK FOOTER //
// ./src/components/FilterControl/index.js